<script>
import {useThemeStore} from "@js/store/ThemeStore.js";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import CartProduct from "@js/components/Sections/Cart/Components/CartProduct.vue";
import CartSummary from "@js/components/Sections/Cart/Components/CartSummary.vue";
import {useCartStore} from "@js/store/CartStore.js";
import CartEmpty from "@js/components/Sections/Cart/CartEmpty.vue";
import CartSuccessPopup from "@js/components/Sections/Popup/CartSuccessPopup.vue";
import IconTrash from "@js/components/Icons/IconTrash.vue";

export default {
  name: "CartPage",
  components: {IconTrash, CartSuccessPopup, CartEmpty, CartSummary, CartProduct, Breadcrumbs},
  beforeMount() {
    this.themeStore.activateLightTheme()
  },
  setup() {
    const themeStore = useThemeStore()
    const cartStore = useCartStore()

    themeStore.turnOffMap()

    return {themeStore, cartStore}
  }
}
</script>

<template>
  <div class="pt-10 md:pt-20 pb-20">
    <div class="container mx-auto">
      <div class="mb-5">
        <h1 class="text-2xl md:text-2xl font-bold text-black mb-2">
          Ваш заказ
        </h1>
        <Breadcrumbs class="mb-2"/>
        <hr class="mt-3 hidden md:block"/>
      </div>
      <section v-if="cartStore.cart.length > 0">
        <div class="grid grid-cols-12 mt-6 sm:mt-8 gap-5">
          <div class="col-span-12 md:col-span-7 lg:col-span-8">
            <div class="space-y-5">
              <CartProduct v-for="cartItem in cartStore.cart" :product="cartItem"/>
            </div>
            <hr class="mt-5 mb-2">
            <div @click.prevent="cartStore.clearCart"
                 class="flex items-center font-bold text-sm text-gray-700 hover:text-red-600 transition cursor-pointer leading-2">
              <IconTrash class="w-5 h-5 me-1"/>
              Очистить корзину
            </div>
          </div>
          <div class="col-span-12 md:col-span-5 lg:col-span-4">
            <CartSummary/>
          </div>
        </div>
      </section>
      <section v-else>
        <CartEmpty/>
      </section>
    </div>
  </div>
  <CartSuccessPopup/>
</template>

<style scoped lang="scss">

</style>
